import { render, staticRenderFns } from "./PutOrderRealTimeContainer.vue?vue&type=template&id=145f3a53&scoped=true&"
import script from "./PutOrderRealTimeContainer.vue?vue&type=script&lang=js&"
export * from "./PutOrderRealTimeContainer.vue?vue&type=script&lang=js&"
import style0 from "./PutOrderRealTimeContainer.vue?vue&type=style&index=0&id=145f3a53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f3a53",
  null
  
)

export default component.exports